import { useReducer, useEffect } from "react";
const initialState = [true, void 0, void 0, false];
function reducer(state, action) {
  switch (action.type) {
    case "RESET":
      return initialState;
    case "CALLED":
      return [true, void 0, void 0, true];
    case "SUCCESS":
      return [false, action.payload, void 0, true];
    case "FAILURE":
      return [false, void 0, action.payload, true];
  }
}
function useApiClient(apiFunc, options, ...params) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    let cancelled = false;
    dispatch({ type: "RESET" });
    if (options && options.skip) {
      return;
    }
    dispatch({ type: "CALLED" });
    apiFunc(...params).then((result) => cancelled || dispatch({ type: "SUCCESS", payload: result })).catch((error) => cancelled || dispatch({ type: "FAILURE", payload: error }));
    return () => {
      cancelled = true;
    };
  }, [options && options.skip, ...params]);
  return state;
}
export {
  useApiClient
};
//# sourceMappingURL=use-api-client.js.map
